import { z } from "zod";

export const sessionStatusEnum = z.enum([
  "authenticated",
  "loading",
  "unauthenticated",
]);

export type SessionStatus = z.infer<typeof sessionStatusEnum>;
